/* Patitas de Papel · «Hojea el libro» (oct 2026)
   Lector a pantalla completa con efecto de pasar página (StPageFlip, licencia MIT, se carga solo al abrir). */
(function () {
  'use strict';
  if (window.__ppLibro) return;
  window.__ppLibro = true;

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) for (var a in attrs) { if (a === 'class') n.className = attrs[a]; else n.setAttribute(a, attrs[a]); }
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function withWidth(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u; }
  function track(accion, extra) {
    try { var d = { accion: accion }; if (extra) for (var k in extra) d[k] = extra[k]; if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pp_libro', d); } catch (e) {}
  }
  var libPromise = null;
  function loadLib(src) {
    if (window.St && window.St.PageFlip) return Promise.resolve();
    if (libPromise) return libPromise;
    libPromise = new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
    return libPromise;
  }
  function goBuy() {
    var btn = document.querySelector('button.Sd_addProduct') || document.querySelector('form[action*="/cart/add"]:not(.pp-form) [type=submit]');
    if (btn && btn.offsetParent) btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); else window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Lista de páginas del lector: tapa, guarda, páginas del libro, cierre
  function pagesFor(lb) {
    var list = [{ t: 'tapa', src: lb.tapa, hard: true, label: 'Tapa' }, { t: 'guarda', src: lb.guarda, label: 'Guarda' }];
    lb.paginas.forEach(function (p) { list.push({ t: 'pag', n: p.n, src: p.src, label: 'Pág. ' + p.n }); });
    list.push({ t: 'fin', hard: true, label: 'Fin' });
    return list;
  }

  function Hojea(root) {
    var node = $('script[type="application/json"]', root);
    if (!node) return;
    try { this.cfg = JSON.parse(node.textContent); } catch (e) { return; }
    this.root = root;
    this.esp = this.cfg.esp || 'michi';
    try { var q = new URLSearchParams(location.search).get('libro'); if (this.cfg.dual && (q === 'michi' || q === 'pupi')) this.esp = q; } catch (e) {}
    this.build();
    var self = this;
    document.addEventListener('pp:esp', function (e) { if (self.cfg.dual && e.detail && e.detail !== self.esp) self.setEsp(e.detail, true); });
  }
  Hojea.prototype.libro = function () { return this.cfg.libros[this.esp]; };

  Hojea.prototype.build = function () {
    var self = this, cfg = this.cfg, mount = $('[data-pp-mount]', this.root);
    mount.innerHTML = '';
    if (cfg.dual) {
      var seg = el('div', { class: 'pp-seg', role: 'tablist', 'aria-label': 'Elige qué libro hojear' });
      ['michi', 'pupi'].forEach(function (k) {
        var b = el('button', { type: 'button', role: 'tab', 'data-esp': k, 'aria-selected': k === self.esp ? 'true' : 'false' }, k === 'michi' ? '🐱 Libro Michi' : '🐶 Libro Pupi');
        if (k === self.esp) b.className = 'is-on';
        b.addEventListener('click', function () { self.setEsp(k); });
        seg.appendChild(b);
      });
      mount.appendChild(seg); this.seg = seg;
    }
    var grid = el('div', { class: 'pp-hj__grid' });
    var book = el('div', { class: 'pp-hj__book' });
    var cover = el('button', { type: 'button', class: 'pp-cover' });
    cover.innerHTML = '<span class="pp-cover__page"><img alt="" loading="lazy" decoding="async"></span><span class="pp-cover__front"><img alt="" loading="lazy" decoding="async"></span><span class="pp-cover__cta">📖 Abrir el libro</span>';
    cover.addEventListener('click', function () { self.open(0, cover); });
    book.appendChild(cover); grid.appendChild(book); this.cover = cover;
    var caps = el('div', { class: 'pp-caps', role: 'list' });
    grid.appendChild(caps); this.caps = caps;
    mount.appendChild(grid);
    if (cfg.modo === 'portada' || cfg.modo === 'pagina') {
      var buy = el('div', { class: 'pp-hj__buy' }); mount.appendChild(buy); this.buy = buy;
    }
    this.render();
    // la tapa se entreabre una vez cuando la sección aparece
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); setTimeout(function () { cover.classList.add('is-peek'); setTimeout(function () { cover.classList.remove('is-peek'); }, 1300); }, 500); loadLib(cfg.lib).catch(function () {}); }
      }, { threshold: .45 });
      io.observe(cover);
    }
  };

  Hojea.prototype.render = function () {
    var self = this, lb = this.libro(), cfg = this.cfg;
    this.root.setAttribute('data-esp', this.esp);
    $all('[data-pp-libro]', this.root).forEach(function (n) { n.textContent = lb.nombre; });
    $all('[data-pp-total]', this.root).forEach(function (n) { n.textContent = lb.paginas.length; });
    var ci = $all('img', this.cover);
    ci[0].src = withWidth(lb.paginas[0].src, 600); ci[1].src = withWidth(lb.tapa, 600);
    ci[1].alt = 'Tapa del Libro ' + lb.nombre;
    this.cover.setAttribute('aria-label', 'Abrir el Libro ' + lb.nombre + ' y hojearlo');
    $all('[data-pp-deco]', this.root).forEach(function (d) { var s = d.getAttribute('data-' + self.esp); if (s) d.src = s; });
    this.caps.innerHTML = '';
    var pages = pagesFor(lb);
    lb.capitulos.forEach(function (c, i) {
      var idx = 0; for (var j = 0; j < pages.length; j++) if (pages[j].n === c.desde) { idx = j; break; }
      var b = el('button', { type: 'button', class: 'pp-cap', role: 'listitem' });
      b.innerHTML = '<img src="' + esc(c.img) + '" alt="" loading="lazy" decoding="async" width="640" height="480"><span>' + esc(c.eyebrow) + '</span><strong>' + esc(c.titulo) + '</strong><em>' + c.paginas + ' páginas</em>';
      b.setAttribute('aria-label', 'Abrir el libro en ' + c.titulo);
      b.addEventListener('click', function () { self.open(idx, b); track('capitulo', { libro: self.esp, cap: c.titulo }); });
      self.caps.appendChild(b);
    });
    var all = el('button', { type: 'button', class: 'pp-cap pp-cap--all', role: 'listitem' }, '<b>📖</b><strong>Desde la tapa</strong><em>Hojéalo completo</em>');
    all.addEventListener('click', function () { self.open(0, all); });
    this.caps.appendChild(all);
    if (this.buy) {
      this.buy.innerHTML = '';
      this.buy.appendChild(this.buyForm('hojea-portada', false));
      this.buy.appendChild(el('p', { class: 'pp-hj__meta' }, '🚚 Envío gratis a todo Chile · <a href="' + esc(lb.url) + '">Ver detalles del libro →</a>'));
    }
  };

  Hojea.prototype.buyForm = function (origen, compact) {
    var lb = this.libro(), cfg = this.cfg;
    if (cfg.modo === 'pack') {
      var b = el('button', { type: 'button', class: 'pp-btn' }, 'Elegir mi pack →');
      var self = this; b.addEventListener('click', function () { self.close(); goBuy(); });
      return b;
    }
    var f = el('form', { method: 'post', action: '/cart/add', 'accept-charset': 'UTF-8', class: 'pp-form' });
    f.innerHTML = '<input type="hidden" name="id" value="' + lb.variante + '"><input type="hidden" name="quantity" value="1"><input type="hidden" name="properties[_origen]" value="' + origen + '">';
    var txt = cfg.modo === 'producto' ? 'Quiero empezar su historia · ' + lb.precio : 'Agregar Libro ' + lb.nombre + ' · ' + lb.precio;
    var sb = el('button', { type: 'submit', class: 'pp-btn' }, lb.disponible ? esc(txt) : 'Agotado por ahora');
    if (!lb.disponible) sb.disabled = true;
    f.appendChild(sb);
    var self2 = this;
    f.addEventListener('submit', function () {
      try {
        var n2 = sessionStorage.getItem('pp_mascota'), e2 = sessionStorage.getItem('pp_esp');
        if (n2 && e2 === self2.esp && !f.querySelector('input[name="properties[_mascota]"]')) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[_mascota]'; h.value = n2; f.appendChild(h); }
      } catch (e) {}
      track('agregar', { libro: self2.esp, origen: origen });
    });
    return f;
  };

  Hojea.prototype.setEsp = function (k, fromOther) {
    if (k === this.esp) return;
    this.esp = k;
    if (this.seg) $all('button', this.seg).forEach(function (b) { var on = b.getAttribute('data-esp') === k; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    this.render();
  };

  /* ---------- Lector ---------- */
  Hojea.prototype.open = function (startIdx, trigger) {
    var self = this, lb = this.libro();
    this.trigger = trigger || null;
    track('abrir', { libro: this.esp, desde: startIdx });
    var rd = this.reader();
    rd.classList.add('is-open');
    document.documentElement.classList.add('pp-lock');
    $('.pp-rd__title', rd).innerHTML = 'Libro ' + esc(lb.nombre) + '<small data-rd-count>Cargando…</small>';
    $('.pp-rd__x', rd).focus();
    loadLib(this.cfg.lib).then(function () { self.mountBook(startIdx || 0); }).catch(function () {
      $('[data-rd-count]', rd).textContent = 'No pudimos abrir el libro. Revisa tu conexión.';
    });
  };

  Hojea.prototype.reader = function () {
    if (this.rd) return this.rd;
    var self = this;
    var rd = el('div', { class: 'pp-rd', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Libro por dentro' });
    rd.innerHTML = '<div class="pp-rd__top"><button type="button" class="pp-rd__x" aria-label="Cerrar">✕</button><div class="pp-rd__title"></div></div>' +
      '<div class="pp-rd__chips" role="tablist" aria-label="Capítulos"></div>' +
      '<div class="pp-rd__stage"><div class="pp-rd__book"></div></div>' +
      '<div class="pp-rd__nav"><button type="button" class="pp-rd__arrow" data-dir="-1" aria-label="Página anterior">‹</button><span class="pp-rd__hint">Desliza o toca los bordes</span><button type="button" class="pp-rd__arrow" data-dir="1" aria-label="Página siguiente">›</button></div>' +
      '<div class="pp-rd__cta"></div>';
    $('.pp-rd__x', rd).addEventListener('click', function () { self.close(); });
    $all('.pp-rd__arrow', rd).forEach(function (b) { b.addEventListener('click', function () { if (!self.pf) return; if (b.getAttribute('data-dir') === '1') self.pf.flipNext(); else self.pf.flipPrev(); }); });
    document.addEventListener('keydown', function (e) {
      if (!rd.classList.contains('is-open')) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowRight' && self.pf) self.pf.flipNext();
      else if (e.key === 'ArrowLeft' && self.pf) self.pf.flipPrev();
    });
    var rt = null;
    window.addEventListener('resize', function () {
      if (!rd.classList.contains('is-open') || !self.pf) return;
      clearTimeout(rt); rt = setTimeout(function () { var cur = self.pf.getCurrentPageIndex(); self.mountBook(cur); }, 250);
    });
    document.body.appendChild(rd);
    this.rd = rd;
    return rd;
  };

  Hojea.prototype.mountBook = function (startIdx) {
    var self = this, rd = this.rd, lb = this.libro(), cfg = this.cfg;
    var stage = $('.pp-rd__stage', rd);
    if (this.pf) { try { this.pf.destroy(); } catch (e) {} this.pf = null; }
    this.pagesList = pagesFor(lb);
    this.renderChips();
    this.renderCta();
    var old = $('.pp-rd__frame', stage); if (old) old.remove();
    var frame = el('div', { class: 'pp-rd__frame' });
    var host = el('div', { class: 'pp-rd__book' });
    frame.appendChild(host);
    stage.appendChild(frame);
    var pages = this.pagesList;
    var sw = stage.clientWidth - 8, sh = stage.clientHeight - 8;
    var land = sw >= 640 && sw / sh > .95;
    var pageW = land ? Math.min(sw / 2, sh * 2 / 3) : Math.min(sw, sh * 2 / 3);
    pageW = Math.floor(Math.max(160, pageW));
    var pageH = Math.floor(pageW * 1.5);
    frame.style.width = (land ? pageW * 2 : pageW) + 'px';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var imgW = pageW * dpr > 760 ? 1000 : (pageW * dpr > 520 ? 760 : 520);
    pages.forEach(function (p, i) {
      var d = el('div', { class: 'pp-pg' });
      if (p.hard) d.setAttribute('data-density', 'hard');
      if (p.t === 'fin') {
        d.innerHTML = '<div class="pp-pg--end">' + (lb.ilu ? '<img src="' + esc(lb.ilu) + '" alt="">' : '') + '<strong>Esto es solo una parte</strong><span>El Libro ' + esc(lb.nombre) + ' tiene 140 páginas para escribir su historia con tu letra: capítulos, actividades, espacios para fotos y una novela ilustrada.</span>' +
          '<button type="button" data-pp-fin>' + (cfg.modo === 'pack' ? 'Elegir mi pack →' : 'Quiero empezar su historia →') + '</button></div>';
      } else {
        var alt = p.t === 'tapa' ? 'Tapa del Libro ' + lb.nombre : (p.t === 'guarda' ? 'Guarda del libro' : 'Libro ' + lb.nombre + ', página ' + p.n);
        d.innerHTML = '<img alt="' + esc(alt) + '" data-src="' + esc(withWidth(p.src, imgW)) + '" width="' + pageW + '" height="' + pageH + '">';
      }
      host.appendChild(d);
    });
    var minW = land ? Math.floor(pageW) : pageW;
    var pf = new window.St.PageFlip(host, {
      width: pageW, height: pageH, size: 'fixed', minWidth: minW, maxWidth: pageW, minHeight: pageH, maxHeight: pageH,
      showCover: true, usePortrait: true, autoSize: true, maxShadowOpacity: .45, mobileScrollSupport: false,
      flippingTime: 750, startPage: 0, drawShadow: true, swipeDistance: 24, disableFlipByClick: false
    });
    this.pf = pf;
    var items = this.items = $all('.pp-pg', host);
    this.loadAround(items, startIdx || 0);
    pf.on('flip', function (e) { self.afterFlip(e.data); });
    pf.on('changeState', function (e) { if ((e.data === 'user_fold' || e.data === 'fold_corner' || e.data === 'flipping') && self.pf) self.loadAround(null, self.pf.getCurrentPageIndex(), 5); });
    pf.loadFromHTML(items);
    host.addEventListener('click', function (e) { var t = e.target && e.target.closest ? e.target.closest('[data-pp-fin]') : null; if (t) { e.preventDefault(); self.finCta(); } });
    if (startIdx) { try { pf.turnToPage(startIdx); } catch (e) {} }
    this.afterFlip(pf.getCurrentPageIndex());
  };

  Hojea.prototype.loadAround = function (items, idx, span) {
    var a = Math.max(0, idx - 2), b = Math.min(this.pagesList.length - 1, idx + (span || 5));
    var hostItems = this.items || [];
    for (var i = a; i <= b; i++) {
      var it = hostItems[i]; if (!it) continue;
      var im = it.querySelector('img[data-src]'); if (im && !im.getAttribute('src')) im.setAttribute('src', im.getAttribute('data-src'));
    }
  };

  Hojea.prototype.afterFlip = function (idx) {
    var rd = this.rd, pages = this.pagesList, pf = this.pf;
    this.loadAround(null, idx, 5);
    var land = pf && pf.getOrientation() === 'landscape';
    var lbl;
    var p = pages[idx];
    if (land && idx > 0 && idx < pages.length - 1) {
      var a = idx % 2 === 1 ? idx : idx - 1, b2 = a + 1;
      var pa = pages[a], pb = pages[b2];
      if (pa && pb && pa.n && pb.n) lbl = 'Págs. ' + pa.n + '–' + pb.n + ' de 140';
      else if (pb && pb.n) lbl = 'Pág. ' + pb.n + ' de 140';
      else lbl = pa ? pa.label : '';
    } else lbl = p && p.n ? 'Pág. ' + p.n + ' de 140' : (p ? (p.t === 'tapa' ? 'Tapa · toca para abrir' : (p.t === 'fin' ? '¿Te gustó?' : p.label)) : '');
    var c = $('[data-rd-count]', rd); if (c) c.textContent = lbl;
    var arrows = $all('.pp-rd__arrow', rd);
    arrows[0].disabled = idx <= 0;
    arrows[1].disabled = idx >= pages.length - 1;
    // capítulo activo
    var lb = this.libro(), cur = null;
    var n = p && p.n ? p.n : (idx > 0 && pages[idx + 1] && pages[idx + 1].n ? pages[idx + 1].n : 0);
    lb.capitulos.forEach(function (ch) { if (n >= ch.desde) cur = ch.titulo; });
    $all('.pp-rd__chips button', rd).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-cap') === (cur || '')); });
    if (!this._seen) this._seen = {};
    if (!this._seen[idx]) { this._seen[idx] = 1; var k = Object.keys(this._seen).length; if (k === 6 || k === 20) track('paginas', { libro: this.esp, vistas: k }); }
  };

  Hojea.prototype.renderChips = function () {
    var self = this, rd = this.rd, lb = this.libro(), pages = this.pagesList;
    var box = $('.pp-rd__chips', rd); box.innerHTML = '';
    var mk = function (label, idx, key) {
      var b = el('button', { type: 'button', 'data-cap': key }, esc(label));
      b.addEventListener('click', function () { if (!self.pf) return; self.loadAround(null, idx, 5); try { self.pf.flip(idx); } catch (e) { self.pf.turnToPage(idx); } });
      box.appendChild(b);
    };
    mk('Tapa', 0, '');
    lb.capitulos.forEach(function (ch) {
      var idx = 0; for (var j = 0; j < pages.length; j++) if (pages[j].n === ch.desde) { idx = j; break; }
      mk(ch.corto || ch.titulo, idx, ch.titulo);
    });
  };

  Hojea.prototype.renderCta = function () {
    var box = $('.pp-rd__cta', this.rd); box.innerHTML = '';
    box.appendChild(this.buyForm(this.cfg.modo === 'producto' ? 'hojea-libro' : 'hojea-portada', true));
  };

  Hojea.prototype.finCta = function () {
    var f = $('.pp-rd__cta form', this.rd);
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    else { this.close(); goBuy(); }
  };

  Hojea.prototype.close = function () {
    if (!this.rd) return;
    this.rd.classList.remove('is-open');
    document.documentElement.classList.remove('pp-lock');
    if (this.trigger && this.trigger.focus) this.trigger.focus({ preventScroll: true });
    if (this._seen) track('cerrar', { libro: this.esp, vistas: Object.keys(this._seen).length });
  };

  function init() { $all('[data-pp-hj]').forEach(function (r) { if (!r.__pp) r.__pp = new Hojea(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
